import WebinarWelcomeMessage from "joynt/components/SessionPage/WebinarWelcomeMessage";

export default {
    "webinar-welcome-message": WebinarWelcomeMessage,
}